// extracted by mini-css-extract-plugin
export default {"Bluecheese":"#615CFF","loadingWrapper":"Ga0a620","title":"G4f0f86","addressSubTitle":"Ga1f977","changeAddress":"G27712b G519ebe","mobileAddressesList":"G37a593"};